import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const SendIcon = ({ color = '#fff', size = '18', ...props }) => (
  <svg width={size} viewBox="0 0 16 17" {...props}>
    <path
      d="M16.16 7.177 1.265.562A.9.9 0 0 0 0 1.385v5.278L8 8 0 9.337v5.278a.9.9 0 0 0 1.266.823L16.16 8.823a.9.9 0 0 0 0-1.646Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

SendIcon.propTypes = propTypes;

export default SendIcon;
